import { useState } from 'react';
import './App.css'
import Home from './Pages/Home/Home';
import Navigation from './Pages/Navigation/Navigation';
import Sidebar from './Pages/Sidebar/Sidebar';

function App() {
  const [openNavigation, setopenNavigation] = useState(false);
  const scrollhome = () => {
    setopenNavigation(false);
    window.scrollBy(0, 0)
  }
  const scrollabout = () => {
    setopenNavigation(false);
    window.scrollBy(0, 1350)
  }
  const scrollskill = () => {
    setopenNavigation(false);
    window.scrollBy(0, 2400)
  }
  const scrollprojects = () => {
    setopenNavigation(false);
    window.scrollBy(0, 3100)
  }
  const scrollcontact = () => {
    setopenNavigation(false);
    window.scrollBy(0, 5600)
  }
  return (
    <>
      <div className="App">
        {openNavigation ? <Navigation handleopenNav={setopenNavigation} opennav={openNavigation} scrollhome={scrollhome} scrollabout={scrollabout} scrollskill={scrollskill} scrollprojects={scrollprojects} scrollcontact={scrollcontact} /> : ''}
        <Home handleopenNav={setopenNavigation} opennav={openNavigation} />
        <Sidebar />
      </div>
    </>
  );
}

export default App;
